import { createFeatureSelector, createSelector } from '@ngrx/store';

import { incidentsAdapter, type IncidentsState } from './incidents.reducer';

const { selectAll } = incidentsAdapter.getSelectors();

export const selectIncidentsState = createFeatureSelector<IncidentsState>('incidents');

export const selectAllIncidents = createSelector(selectIncidentsState, selectAll);

export const selectIncidentsCount = createSelector(
  selectAllIncidents,
  state => state.length,
);

export const isIncidentLoaded = createSelector(selectIncidentsState, state => state.isLoaded);

export const selectLocationIncidents = (locationId: string) =>
  createSelector(selectAllIncidents, state =>
    state.filter(incident => incident.device.locationId === locationId || incident.device.location.id === locationId),
  );

export const selectSpaceIncidents = (spaceId: string) =>
  createSelector(selectAllIncidents, state =>
    state.filter(incident => incident.device.spacePath?.some(space => space.id === spaceId)),
  );

export const selectIncidentsByDeviceId = (deviceId: string) =>
  createSelector(selectAllIncidents, state => state.filter(incident => incident.device.id === deviceId));
